__turbopack_context__.v({
  "wrapper": "FullImage-module-scss-module__fLa3TG__wrapper",
});
